/**
 * Google auto-complete service
 */
export default class GooglePlaces {
  constructor() {
    this.service = window.google.maps.places;
  }

  init() {
    new this.service.AutocompleteService();
  }
}
